import {SelectValue} from '@/components/commons/select/Select'
import {HttpAccountsResponse} from '@/features/account/services/account.http'

export const accountsSelectAdapter = (response: HttpAccountsResponse): SelectValue[] =>
    response.data.map(item => ({value: item.idAccount.toString(), label: item.displayName ?? '--'}))
